const formatPrice = (price, unit = '', zero = '무료') => {
  if (price === 0) return zero.toString();
  return `${price.toLocaleString('ko-KR')}${unit}`;
};
export default formatPrice;
